export const translation = {
  logout: 'Déconnexion',
  userSettings: 'Voir mon profil',
  admin: 'Administration',
  notConnected: 'Pas connecté',
  otherLanguage: 'English',
  tabTitle: 'Portail PMP Solutions',
  buttons: {
    cancel: 'Annuler',
    submit: 'Soumettre',
    retry: 'Réessayer',
  },
  errors: {
    loadingError: 'Une erreur est survenue lors du chargement des données.',
  },
  reports: {
    loading: 'Chargement...',
    errorLoading: 'Erreur lors du chargement des rapports',
    pleaseSelectAReport: 'Veuillez sélectionner un rapport pour le visualiser.',
    reportListTitle: 'Rapports',
    analyticsTitle: 'Analytique',
    favoritesTitle: 'Favoris',
    noReportSelected: 'Aucun rapport de sélectionné',
    refreshingReport: 'Actualisation du rapport...',
    refreshReportFailed: "Impossible d'actualiser ce rapport. Veuillez recharger la page.",
    // Keyed by the raw Power BI report name (Power BI has no per-culture display name of its own).
    // Reports missing here fall back to their raw name instead of breaking.
    reportNames: {
      Downtimes: "Temps d'arrêt",
      QcReport: 'Contrôle qualité',
      'Planing Feedback': 'Opérations de rabotage',
      Sawing: 'Opérations de Sciage',
    },
  },
  help: {
    myOrganization: 'Mon organisation',
    needHelp: "Besoin d'aide ?",
    helpCenter: "Centre d'aide",
    supportRequests: 'Support / Demandes',
    bookMeeting: 'Réserver une réunion',
    email: 'Courriel',
    visit: 'Visitez pmpsolutions.ca',
    noSites: "Vous n'avez pas de site assigné",
  },
  home: {
    welcome: 'Bienvenue, {{name}} !',
    description:
      'Bienvenue dans PMP TeamMate. Prenez le contrôle de votre scierie grâce à des tableaux de bord puissants et des rapports détaillés pour chaque produit que vous gérez.',
    selectFromSidebar:
      'Sélectionnez un produit ou un rapport dans la barre latérale pour commencer ou téléchargez notre application bureau.',
    restartOnboarding: 'Commencer le tutoriel de démarrage',
    restartOnboardingAction: 'Commencer',
  },
  downloadApp: {
    title: 'Application de bureau',
    homeTitle: "Télécharger l'application PMP TeamMate",
    downloadButton: 'Télécharger PMP TeamMate',
    description: 'Accédez à des fonctionnalités et des outils supplémentaires avec notre application de bureau',
    requiresConnection: "Nécessite une connexion au réseau de l'usine",
  },
  supportForm: {
    name: 'Nom',
    email: 'Adresse courriel',
    millName: "Nom de l'usine",
    phone: 'Téléphone',
    addFiles: 'Ajouter des fichiers',
    title: 'Titre',
    details: 'Décrivez votre problème. Ajoutez des détails pour que nous puissions vous aider plus efficacement.',
    description: 'Description',
    descriptionRequired: 'La description est requise',
    errorMessage: "Une erreur s'est produite lors de la soumission du ticket.",
  },
  dashboards: {
    refreshEvery5Minutes:
      "Vous devez être connecté du réseau local de l'usine pour accéder aux tableaux de bord en temps réel. Les aperçus sont rafraichis aux 15 minutes.",
    dashboards: 'Tableaux de bord',
    openLiveDashboard: 'Ouvrir le tableau de bord en direct',
    live: {
      loading: 'Connexion…',
      online: 'En direct',
      offline: 'Hors ligne',
      offlineSince: 'Hors ligne depuis {{time}}',
      unavailable: 'Indisponible',
      openInNewTab: 'Ouvrir dans un onglet',
      notFound: "Ce tableau de bord n'est pas disponible sur ce site.",
    },
  },
  products: {
    myProducts: 'Mes produits',
    otherProducts: 'Autres produits',
    inConstruction: 'Cette page est en construction',
  },
  resourceReports: {
    reports: 'Rapports (pdf)',
    selectEquipment: 'Sélectionner un équipement',
    browseAllReports: 'Parcourir tous les rapports disponibles',
    shift: 'Faction :',
    day: 'Jour :',
    current: 'Actuel',
    last: 'Dernier',
    fiscal: 'Fiscal',
    lastFiscal: 'Dernier fiscal',
    today: 'Aujourd’hui',
    week: 'Semaine :',
    month: 'Mois :',
    year: 'Année :',
    yesterday: 'Hier',
    currentFiscal: 'Fiscal actuel',
    unavailable: 'Rapport non disponible',
  },
  tools: {
    tools: 'Outils',
    downtimeDocumentation: 'Documentation des temps d’arrêt',
    editGaugeLimits: 'Modifier les limites opérationnelles',
    reportsPortal: 'Portail des rapports',
  },
  connection: {
    dashboardAndToolsNotAvailable:
      'Les tableaux de bord et les outils en direct ne sont disponibles que lorsque vous êtes connectés au réseau de votre usine',
    documentationToolNotAvailable:
      'La documentation des temps d’arrêt n’est disponible que lorsque vous êtes connecté au réseau de votre usine',
  },
  migration: {
    title: 'Action requise',
    description: 'Vous devez réinitialiser votre mot de passe pour continuer à accéder au portail.',
    securityNote:
      "Cette mise à jour renforce la sécurité de la plateforme et l'aligne avec les meilleures pratiques actuelles.",
    securityNotePart1: "Il s'agit d'une mesure préventive, ",
    securityNoteBold: 'non liée à un incident de sécurité.',
    requirementsPart1: 'Cette étape est requise pour ',
    requirementsPart2Bold: 'tous les utilisateurs',
    requirementsPart3: '. Votre ancien mot de passe ne fonctionnera plus.',
    procedureTitle: 'Comment procéder :',
    step1Part1: 'Cliquez sur ',
    step1Bold: '« Continuer vers la connexion »',
    step2Part1: 'Entrez votre courriel et cliquez sur ',
    step2Bold: '« Suivant »',
    step3Part1: 'Cliquez sur ',
    step3Bold: '« Mot de passe oublié ? »',
    step4: 'Suivez les étapes pour créer votre nouveau mot de passe',
    supportPart1: "Besoin d'aide? ",
    supportLink: 'Contactez notre équipe de support',
    supportPart2: '.',
    proceedToLoginButton: 'Continuer vers la connexion',
  },
  sessionExpired: {
    title: 'Connexion requise',
    description: "Votre session a pris fin ou n'a pas pu être ouverte. Veuillez vous connecter pour continuer.",
    signIn: 'Se connecter',
  },
  bootstrapError: {
    title: 'Site temporairement indisponible',
    description:
      'Le portail est en cours de changement pour devenir multi-site. Merci de votre patience durant cette transition.',
    firstLogin:
      "Veuillez réessayer dans quelques instants en cliquant sur le bouton « Réessayer » pour obtenir l'accès.",
    contact: 'Si le problème persiste, veuillez contacter le support :',
    retry: 'Réessayer',
    backToLogin: 'Retour à la connexion',
  },
  userSettingsPage: {
    title: 'Mon compte',
    phoneNumber: 'Numéro de téléphone :',
    organizationName: "Nom de l'organisation :",
    email: 'Adresse courriel :',
    name: 'Nom d’utilisateur :',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    changePassword: 'Modifiez votre mot de passe', // NOSONAR
    here: 'ici',
    save: 'Sauvegarder',
    saving: 'En sauvegarde...',
    cancel: 'Annuler',
    failSave: 'Impossible d’enregistrer les détails',
    successSave: 'Détails enregistrés avec succès',
    invalidName: 'Nom valide',
    invalidFirstName: 'Prénom invalide',
    invalidLastName: 'Nom de famille invalide',
    invalidPhone: 'Numéro de téléphone invalide',
    profileSection: 'Informations de profil',
    securitySection: 'Paramètres de sécurité',
  },
  adminPage: {
    title: "Tableau de bord d'administration",
    PowerBIReports: 'Rapports Power BI',
  },
  updateAlert: {
    newVersion: 'Une nouvelle version de l’application est disponible. La page se rafraîchira dans ',
    seconds: 'secondes',
    now: 'Rafraîchir maintenant',
  },
  qualityControl: {
    back: 'Retour',
    editTest: 'Modifier le test',
    scheduleActivation: 'Programmer l’activation',
    saveAndActivate: 'Enregistrer et activer',
    pendingVersionBanner:
      'Vous éditez la version {{version}}, active le {{date}}. Rappel: les champs de définition modifiés s’affichent immédiatement; seuls les changements de version sont reportés.',
    definitionTab: 'Définition',
    formSchemaTab: 'Schéma du formulaire',
    scoreParametersTab: 'Paramètres de score',
    displayName: 'Nom affiché',
    category: 'Catégorie',
    description: 'Description',
    displayOrder: 'Ordre d’affichage',
    scoreCalculatorType: 'Type de calcul du score',
    targetTestsPerShift: 'Cible de tests par faction',
    canTestMultipleEntities: 'Peut tester plusieurs entités',
    scheduledActivationDate: 'Date d’activation programmée',
    schedulingHelper: 'La programmation est disponible une fois le test actif.',
    schedulingActiveHelper:
      'Appliqué au formulaire et aux paramètres de score seulement — les champs d’identité sont toujours enregistrés immédiatement.',
    scheduledDateInPastError: 'La date d’activation planifiée doit être dans le futur.',
    testIdentitySection: 'Identité du test',
    testIdentitySectionHelper: 'Toujours enregistré immédiatement, peu importe la programmation.',
    versionContentSection: 'Contenu de version',
    formJsonLabel: 'Formulaire JSON (SurveyJS)',
    mustBeValidJson: 'Doit être un JSON valide — validé à l’enregistrement.',
    addParameter: '+ Ajouter un paramètre',
    saveErrorDefault: 'Une erreur est survenue lors de l’enregistrement du test.',
    version: 'v',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    openSurveyJSCreator: 'Ouvrir SurveyJS Creator',
    error: 'Erreur',
    warning: 'Avertissement',
    success: 'Succès',
    info: 'Info',
    testEditorTitle: 'Éditeur de test',
    testEditorSubtitle: 'Modifiez les détails de votre test de contrôle qualité.',
    testEditorTabs: 'Onglets de l’éditeur de test',
    testEditorForm: 'Formulaire de l’éditeur de test',
    testEditorScore: 'Score de l’éditeur de test',
    testEditorParameters: 'Paramètres de l’éditeur de test',
    testEditorSave: 'Enregistrer le test',
    testEditorCancel: 'Annuler',
    testEditorBack: 'Retour',
    testEditorPending: 'En attente',
    testEditorActive: 'Actif',
    testEditorInactive: 'Inactif',
    testEditorScheduled: 'Programmé',
    testEditorVersion: 'Version',
    testEditorActivation: 'Activation',
    testEditorExecutions: 'Exécutions',
    testEditorHistory: 'Historique',
    testEditorDefinition: 'Définition',
    testEditorFormSchema: 'Schéma du formulaire',
    testEditorScoreParameters: 'Paramètres de score',
    testEditorAddParameter: '+ Ajouter un paramètre',
    testEditorMustBeValidJson: 'Doit être un JSON valide — validé à l’enregistrement.',
    testEditorSchedulingHelper: 'La programmation est disponible uniquement après des exécutions existantes',
    testEditorSaveErrorDefault: 'Une erreur est survenue lors de l’enregistrement du test.',
    testEditorOpenSurveyJSCreator: 'Ouvrir la démo SurveyJS Creator',
    averageScoreTooltip: 'Score moyen des 30 derniers jours',
    menuTitle: 'Contrôle Qualité',
    title: 'Tests de Contrôle Qualité',
    noTests: 'Aucun test de contrôle qualité disponible',
    viewForm: 'Voir le formulaire',
    backToList: 'Retour à la liste',
    lastUpdated: 'Date de version',
    errorLoading: 'Erreur lors du chargement des tests',
    uncategorized: 'Non catégorisé',
    executeTest: 'Nouveau test',
    viewHistory: 'Historique',
    averageScore: 'Score Moyen',
    executionCount: 'Exécutions',
    observedBy: 'Observé par',
    versionNumber: 'Version',
    submitting: 'Envoi en cours...',
    submitSuccess: 'Test soumis avec succès. Redirection en cours...',
    submitError: "Une erreur s'est produite lors de la soumission. Veuillez réessayer.",
    retry: 'Réessayer',
    history: "Historique d'exécution",
    noHistory: 'Aucune exécution enregistrée.',
    backToHistory: "Retour à l'historique",
    executionDate: 'Date',
    observedAt: 'Observé le',
    score: 'Score',
    comments: 'Commentaires',
    penalty: 'Pénalité',
    penaltyPerUnit: 'Pénalité/Échelon',
    maxPenalty: 'Pénalité max',
    noParameters: 'Aucun paramètre défini',
    type: 'Type',
    fieldName: 'Nom du champ',
    matrixField: 'Champ matrice',
    actions: 'Actions',
    step: 'Échelon',
    addOption: 'Ajouter une option',
    recomputeAllScores: 'Recalculer tous les scores',
    recomputingScores: 'Recalcul en cours...',
    recomputeSuccess: '{{count}} exécution(s) recalculée(s) avec succès',
    recomputeError: "Une erreur s'est produite lors du recalcul des scores.",
    createTest: 'Créer un nouveau test',
    adminTools: 'Outils admin',
    scoreParametersDisabledTooltip: "Sauvegardez le test d'abord pour configurer les paramètres de score",
    testCreatedSuccess: 'Test créé avec succès',
    recomputeConfirmTitle: 'Recalculer tous les scores ?',
    recomputeConfirmBody:
      'Cela recalculera les scores pour toutes les exécutions de tests. Cela peut prendre un moment.',
    print: 'Imprimer',
    correct: 'Corriger',
    correctionBadge: 'Correction',
    deleted: 'Supprimé',
    deleteExecution: 'Supprimer',
    deleting: 'Suppression...',
    deleteExecutionConfirmTitle: 'Supprimer cette exécution ?',
    deleteExecutionConfirmBody:
      'Cette exécution sera marquée comme supprimée. Elle restera visible dans l’historique mais exclue des scores. Les administrateurs peuvent la restaurer.',
    deleteExecutionSuccess: 'Exécution supprimée avec succès',
    deleteExecutionError: 'Une erreur est survenue lors de la suppression de l’exécution.',
    restoreExecution: 'Restaurer',
    restoring: 'Restauration...',
    restoreExecutionConfirmTitle: 'Restaurer cette exécution ?',
    restoreExecutionConfirmBody: 'Cette exécution sera restaurée et incluse à nouveau dans les calculs de score.',
    restoreExecutionSuccess: 'Exécution restaurée avec succès',
    restoreExecutionError: 'Une erreur est survenue lors de la restauration de l’exécution.',
    deletedExecutionsInRange: '{{count}} exécution(s) supprimée(s) dans la fenêtre de score',
  },
  onboarding: {
    welcome: {
      title: 'Bienvenue!',
      description:
        ' Bienvenue sur le portail PMP Solutions, qui est maintenant multisite! Voici vos sites disponibles, chacun vous donne accès aux outils, rapports et tableaux de bord de l’usine sélectionnée.',
    },
    hub: {
      title: 'Vos sites',
      description:
        ' Cliquez sur un site pour y accéder. Le site que vous choisissez sera ouvert automatiquement lors de votre prochaine connexion.',
    },
    helpButton: {
      title: "Centre d'aide",
      description:
        "Le centre d'aide est maintenant ici. Nous avons mis à jour son contenu pour mieux vous accompagner.",
    },
    helpMenu: {
      title: 'Demandes de support',
      description:
        "Le formulaire de demande d'aide est disponible à l'intérieur de ce menu. C'est votre point de départ pour rejoindre notre équipe de support.",
    },
    breadcrumb: {
      title: 'Chemin de navigation',
      description: 'Ce chemin de navigation indique où vous vous trouvez dans le portail.',
    },
    breadcrumbSite: {
      title: 'Sélection du site',
      description:
        "Vous voyez ici votre site actuel. Si vous avez plusieurs sites, vous pouvez utiliser ce menu pour passer de l'un à l'autre en tout temps.",
    },
    sideBar: {
      title: 'Produits et outils',
      description:
        "La barre latérale vous donne accès à l'ensemble des produits de votre site et aux outils disponibles.",
    },
    sideBarButton: {
      title: 'Affichage de la barre latérale',
      description: 'Vous pouvez ouvrir et fermer la barre latérale à votre guise.',
    },
    productSection: {
      title: 'Vos produits',
      description:
        "La barre latérale se fermera automatiquement pour vous laisser plus d'espace. Vous pouvez toujours utiliser les icônes dans la barre pour naviguer entre produits et outils.",
    },
    breadecrumbProduct: {
      title: 'Sélection du produit',
      description:
        "Le chemin de navigation affiche le produit actuellement sélectionné. Si vous en avez plusieurs, c'est aussi un moyen rapide d'en changer sans repasser par la barre latérale.",
    },
    dashboardsNavigation: {
      title: 'Tableaux de bord',
      description:
        "Utilisez les flèches pour parcourir les aperçus des tableaux de bord. Vous devez être connecté au réseau local de l'usine pour les visualiser en temps réel.",
    },
    documentationButton: {
      title: 'Arrêts de production',
      description:
        "Accédez ici à la documentation de vos arrêts de production. Vous devez être connecté au réseau local de l'usine.",
    },
    reportsSection: {
      title: 'Rapports de production',
      description:
        'Ce bouton vous ouvre le portail des rapports. Les liens ci-dessus vous offrent une petite sélection des rapports disponibles dans le portail.',
    },
    homeButton: {
      title: "Retour à l'accueil",
      description: "Vous pouvez revenir à la page d'accueil à tout moment en cliquant sur ce bouton.",
    },
  },
}
